import React, { Component } from 'react';
import './App.css';
import SimpleChart from './simple-chart/SimpleChart';
import { Button, Navbar, NavItem, Icon, Footer } from 'react-materialize';

const cf = window.cf;

class App extends Component {
  render() {
    return <SimpleChart></SimpleChart>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js